export default "__VITE_ASSET__59732412__"